import Instruments from './Instruments'

export default Instruments
